import { defineStore } from "pinia";

export const useLoadingStore = defineStore("loading", {
    state: () => ({
        isLoading: false
    }),
    actions: {
        setIsLoadingTrue() {
            this.isLoading = true;
        },
        setIsLoadingFalse() {
            this.isLoading = false;
        }
    },
    getters: {
        getIsLoading: (state) => state.isLoading,
    },
})
